import { useEffect, useRef, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import GoogleTranslate from "./GoogleTranslate/GoogleTranslate";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about-us" }, 
     { label: "Services", path: "/services" },
     { label: "Driver Offers", path: "/driver-offers" },
     { label: "Customer Offers", path: "/customer-offers" },
    { label: "Contact Us", path: "/contact-us" },

  ];

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navbarToggleRef = useRef(null);

  const handleNavItemClick = (id) => {
    if (navbarToggleRef.current && window.innerWidth < 991) {
      navbarToggleRef.current.click();
    }
  };

  return (
    <>
      <section className={`Header ${isScrolled ? "active" : ""}`}>
        <Container>
          <div className={`main_menu_navbar`}>
            <Navbar expand="lg">
              <Navbar.Brand >
                <div className="logo_holder">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo/Pm-Road-logo.jpg"}
                    alt="logo"
                    className="nav_logo"
                    onClick={() => navigate("/")}
                  />
                </div>

                <div className="head_logo_holder">
                  <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo/Pm-Road-header-logo.jpg"}                  
                  alt="logo"
                  className="head_logo"
                  onClick={() => navigate("/")}
                  />
                </div>
              </Navbar.Brand>

              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                ref={navbarToggleRef}
              />

              <Navbar.Collapse
                id="basic-navbar-nav"
              // className="d-none d-lg-block"
              >
                <div className="top_bar">
                  <Nav>
                    <>
                      {navItems.map((item, index) => (
                        <Nav.Link
                          as={Link}
                          to={item.path}
                          key={index}
                          className={
                            location.pathname === item.path ? "active" : ""
                          }
                          onClick={handleNavItemClick}
                        >
                          {item.label}
                        </Nav.Link>
                      ))}
                    </>
                     <GoogleTranslate />
                  </Nav>
                  
                </div>
              </Navbar.Collapse>
            </Navbar>
           
          </div>
        </Container>
      </section>
    </>
  );
}

export default Header;
